import {charcoal} from '../../sass/v2/_exports.sass';

export const ConversationIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 18.6667C23.1027 18.6667 24 17.7693 24 16.6667V4.66666C24 3.56399 23.1027 2.66666 22 2.66666H4.66667C3.564 2.66666 2.66667 3.56399 2.66667 4.66666V24L9.77734 18.6667H22ZM8.88933 16L5.33333 18.6667V5.33332H21.3333V16H8.88933Z"
        fill={color}
      />
      <path
        d="M27.3333 10.6667H26.6667V18.668C26.6667 20.1347 25.476 21.3253 24.0133 21.3333H10.6667V22C10.6667 23.1027 11.564 24 12.6667 24H22.2227L29.3333 29.3333V12.6667C29.3333 11.564 28.436 10.6667 27.3333 10.6667Z"
        fill={color}
      />
    </svg>
  );
};
